import { DmaLocationData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { baseChart } from './baseChart';
import dmaMapData from './dma.json';
import baseMap from '@highcharts/map-collection/countries/us/us-all.topo.json';
import { CA_LIGHT_BLUE_COLOR, CA_DARK_BLUE_COLOR } from '@utils/colorGenerator';
import Highcharts from 'highcharts';

export const buildChartOptions = (
  sortedDataItems: DmaLocationData[]
): Highcharts.Options => ({
  ...baseChart,

  colorAxis: {
    type: 'linear',
    minColor: CA_LIGHT_BLUE_COLOR,
    maxColor: CA_DARK_BLUE_COLOR,
  },

  series: [
    {
      type: 'map',
      name: 'Basemap',
      mapData: baseMap,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    {
      type: 'map',
      data: sortedDataItems.map(dataItem => ({
        value: dataItem.visitIndex,
        name: dataItem.location,
        dmaId: dataItem.dmaId,
      })),
      dataLabels: {
        enabled: false,
      },
      joinBy: ['id', 'dmaId'],
      mapData: dmaMapData,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  ],

  tooltip: {
    enabled: true,
    headerFormat: '',
    pointFormat: '{point.name}: {point.value}',
  },

  xAxis: undefined,
});
